import { renderSwiftPackageModule } from "./swiftPackageModule";
function swiftPackagePlugin(platform, root) {
  return {
    name: "one:swift-package",
    load: {
      filter: {
        id: /\.swift$/
      },
      handler(id) {
        var { code, watchFiles } = renderSwiftPackageModule(id, platform, root);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
        try {
          for (var _iterator = watchFiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var file = _step.value;
            this.addWatchFile(file);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        return code;
      }
    }
  };
}
export {
  swiftPackagePlugin
};
//# sourceMappingURL=swiftPackagePlugin.js.map
